import './App.css'

import {Banner, Experience, Footer, Navbar, Projects, Skills} from './page'

const App = () => {
  return (
    <>
      <Navbar />
      <Banner />
      <Skills />
      <Experience />
      <Projects />
      <Footer />
    </>
  )
}

export default App
